{
  "background": {
    "default": {
      "$type": "color",
      "$description": "Page canvas — the base background behind all content.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.9803921568627451,
          0.9803921568627451
        ],
        "alpha": 1,
        "hex": "#fafafa"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Subtly differentiated background for alternating or grouped sections.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9607843137254902,
          0.9607843137254902,
          0.9607843137254902
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    }
  },
  "surface": {
    "default": {
      "$type": "color",
      "$description": "Default container surface — cards, panels, and inputs on the page.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          1,
          1
        ],
        "alpha": 1,
        "hex": "#ffffff"
      }
    },
    "raised": {
      "$type": "color",
      "$description": "Raised surface for higher-elevation layers (menus, popovers, dialogs). Higher elevation reads lighter in dark mode.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          1,
          1
        ],
        "alpha": 1,
        "hex": "#ffffff"
      }
    },
    "sunken": {
      "$type": "color",
      "$description": "Recessed surface for wells and inset regions.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9607843137254902,
          0.9607843137254902,
          0.9607843137254902
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    }
  },
  "text": {
    "default": {
      "$type": "color",
      "$description": "Primary body and heading text.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.054901960784313725,
          0.06666666666666667,
          0.07450980392156863
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    },
    "muted": {
      "$type": "color",
      "$description": "Secondary text — supporting copy, captions, metadata.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.28627450980392155,
          0.3137254901960784,
          0.32941176470588235
        ],
        "alpha": 1,
        "hex": "#495054"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tertiary text — placeholders and disabled labels. The mid-grey reads in both modes.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5333333333333333,
          0.5607843137254902,
          0.5725490196078431
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    },
    "inverse": {
      "$type": "color",
      "$description": "Text and icons rendered on an action or solid fill.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          1,
          1
        ],
        "alpha": 1,
        "hex": "#ffffff"
      }
    },
    "link": {
      "$type": "color",
      "$description": "Inline hyperlink text.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.14901960784313725,
          0.39215686274509803
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    }
  },
  "border": {
    "default": {
      "$type": "color",
      "$description": "Default border for inputs, cards, and dividers.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8627450980392157,
          0.8745098039215686,
          0.8784313725490196
        ],
        "alpha": 1,
        "hex": "#dcdfe0"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Low-emphasis border for subtle separation.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9215686274509803,
          0.9215686274509803,
          0.9215686274509803
        ],
        "alpha": 1,
        "hex": "#ebebeb"
      }
    },
    "strong": {
      "$type": "color",
      "$description": "High-emphasis border for focus and selected states.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5333333333333333,
          0.5607843137254902,
          0.5725490196078431
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    }
  },
  "action": {
    "default": {
      "$type": "color",
      "$description": "Primary interactive colour — buttons, links, key accents. NSW navy in light, brightened for contrast in dark.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.14901960784313725,
          0.39215686274509803
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    },
    "hover": {
      "$type": "color",
      "$description": "Hover and active state for primary actions.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.06274509803921569,
          0.21568627450980393
        ],
        "alpha": 1,
        "hex": "#001037"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tinted background for low-emphasis (ghost) actions.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9411764705882353,
          0.984313725490196,
          1
        ],
        "alpha": 1,
        "hex": "#f0fbff"
      }
    }
  },
  "success": {
    "surface": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — tinted background.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9372549019607843,
          0.9764705882352941,
          0.9294117647058824
        ],
        "alpha": 1,
        "hex": "#eff9ed"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — readable text on the tint.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.35294117647058826,
          0.00784313725490196
        ],
        "alpha": 1,
        "hex": "#005a02"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — border and divider.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5607843137254902,
          0.7803921568627451,
          0.5411764705882353
        ],
        "alpha": 1,
        "hex": "#8fc78a"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.5411764705882353,
          0.027450980392156862
        ],
        "alpha": 1,
        "hex": "#008a07"
      }
    }
  },
  "warning": {
    "surface": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — tinted background.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.9529411764705882,
          0.9294117647058824
        ],
        "alpha": 1,
        "hex": "#fff3ed"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — readable text on the tint.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5333333333333333,
          0.1843137254901961,
          0.011764705882352941
        ],
        "alpha": 1,
        "hex": "#882f03"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — border and divider.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9333333333333333,
          0.6588235294117647,
          0.5411764705882353
        ],
        "alpha": 1,
        "hex": "#eea88a"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.788235294117647,
          0.3137254901960784,
          0
        ],
        "alpha": 1,
        "hex": "#c95000"
      }
    }
  },
  "danger": {
    "surface": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — tinted background.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.9411764705882353,
          0.9372549019607843
        ],
        "alpha": 1,
        "hex": "#fff0ef"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — readable text on the tint.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.48627450980392156,
          0.023529411764705882,
          0.12156862745098039
        ],
        "alpha": 1,
        "hex": "#7c061f"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — border and divider.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9176470588235294,
          0.5725490196078431,
          0.5803921568627451
        ],
        "alpha": 1,
        "hex": "#ea9294"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7215686274509804,
          0.07058823529411765,
          0.21568627450980393
        ],
        "alpha": 1,
        "hex": "#b81237"
      }
    }
  },
  "info": {
    "surface": {
      "$type": "color",
      "$description": "Info (neutral information) — tinted background.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9137254901960784,
          0.9333333333333333,
          0.9686274509803922
        ],
        "alpha": 1,
        "hex": "#e9eef7"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Info (neutral information) — readable text on the tint.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.09803921568627451,
          0.2,
          0.4
        ],
        "alpha": 1,
        "hex": "#193366"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Info (neutral information) — border and divider.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5019607843137255,
          0.596078431372549,
          0.7607843137254902
        ],
        "alpha": 1,
        "hex": "#8098c2"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Info (neutral information) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.1803921568627451,
          0.3215686274509804,
          0.6
        ],
        "alpha": 1,
        "hex": "#2e5299"
      }
    }
  }
}
